import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
})
export class SvgIconComponent implements OnInit {
  @Input() fillColor: string | undefined = '#fff';
  @Input() iconName!: 'icon_create' | 'icon_class';

  constructor() {}

  ngOnInit(): void {}
}
